import { __assign } from "tslib";
import hexToRgba from 'hex-rgba';
import spcColors from './spcColors';
import paletteLight from './paletteLight';
var black = spcColors.black,
    gray = spcColors.gray,
    negative = spcColors.negative,
    accent = spcColors.accent,
    white = spcColors.white,
    light = spcColors.light;

var limexLightPalette = __assign(__assign({}, paletteLight), {
  background: {
    neutral: __assign(__assign({}, paletteLight.background.neutral), {
      primary: '#FFFFFF',
      secondary: '#F4F5F7',
      tertiary: '#EBEFF5',
      popover: '#FFFFFF',
      primaryTransparent: 'rgba(255, 255, 255, 0.64)',
      dialogOverlay: 'rgba(18, 20, 23, 0.64)'
    }),
    semantic: {
      warning: '#FFF2C9',
      accent: '#DAF5DE',
      positive: '#DCF0E8',
      negative: '#FCE3E3',
      positiveGradient: 'linear-gradient(180deg, #171C1B 0%, #142B22 50.47%, #0F402E 100%)',
      negativeGradient: 'linear-gradient(180deg, #29181A 0%, #3B1A1E 50.99%, #63181A 100%)'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #FFFFFF 3.5%, rgba(255, 255, 255, 0) 96.51%)',
      secondary: 'linear-gradient(180deg, #FAFCFE 3.5%, rgba(250, 252, 254, 0) 96.51%)',
      tertiary: 'linear-gradient(180deg, #F0F4FA 3.5%, rgba(240, 244, 250, 0) 96.51%)'
    }
  },
  label: {
    accent: '#0AA461',
    accentHigh: '#099558',
    accentHighest: '#088750',
    primary: '#272F40',
    secondary: '#7486AA',
    secondaryHigh: '#425276',
    tertiary: '#919CB6',
    tertiaryHigh: '#667999',
    placeholder: '#A8B8D2',
    inactive: 'rgba(93, 114, 152, 0.4)',
    positive: '#1B825E',
    negative: '#E83F41',
    warning: '#D49800',
    inverse: '#FFFFFF',
    primaryActive: '#0AA461',
    secondaryActive: '#425276',
    tertiaryActive: '#667999',
    plaseholder: '#A8B8D2'
  },
  fill: __assign(__assign({}, paletteLight.fill), {
    primary: {
      highest: '#089659',
      high: '#0BAD67',
      mid: '#0EBE72',
      low: '#0CDF83',
      muted: '#EBEEEC',
      overlay32: 'rgba(23, 211, 120, 0.32)',
      overlay24: 'rgba(23, 211, 120, 0.24)',
      overlay16: 'rgba(23, 211, 120, 0.16)',
      overlay8: 'rgba(23, 211, 120, 0.08)'
    },
    secondary: {
      highest: '#272F40',
      high: '#5F7095',
      mid: '#8896AF',
      low: '#B9C6DF',
      muted: '#D9E2F7',
      overlay32: 'rgba(167, 189, 241, 0.32)',
      overlay24: 'rgba(167, 189, 241, 0.24)',
      overlay16: 'rgba(167, 189, 241, 0.16)',
      overlay8: 'rgba(167, 189, 241, 0.08)'
    }
  }),
  static: __assign(__assign({}, paletteLight.static), {
    secondary: '#4D566B'
  }),
  divider: __assign(__assign({}, paletteLight.divider), {
    primary: '#E6EFFF',
    secondary: '#F3F7FF',
    altPrimary: '#A4AFC7',
    altSecondary: '#D7E1F5'
  }),
  shadow: {
    button: '0px 1px 3px rgba(39, 47, 64, 0.18)',
    accent: '0px 3px 6px -2px rgba(21, 188, 88, 0.3), 0px 8px 12px rgba(21, 188, 88, 0.1), 0px 9px 16px rgba(56, 124, 255, 0.11)',
    popover: '0px 8px 16px rgba(95, 112, 149, 0.32), 0px 16px 40px rgba(95, 112, 149, 0.12)',
    dialog: '0px 12px 16px rgba(39, 47, 64, 0.1), 0px 24px 56px rgba(39, 47, 64, 0.38)',
    cardEasy: '0px 6px 16px rgba(82, 96, 122, 0.08)',
    cardHeavy: '0px 1px 4px rgba(95, 112, 149, 0.12), 0px 6px 16px rgba(95, 112, 149, 0.2)',
    headerWeb: '0px 1px 4px rgba(8, 55, 155, 0.04), 0px 6px 16px rgba(8, 55, 155, 0.04)'
  },
  base: {
    accent: accent['1'],
    error: negative['1'],
    disabled: gray['3']
  },
  input: {
    main: {
      text: black['1'],
      background: hexToRgba(gray['1'], 8),
      backgroundDisabled: hexToRgba(gray['1'], 4),
      backgroundHover: hexToRgba(gray['1'], 16),
      backgroundError: hexToRgba(negative['1'], 8),
      border: gray['3'],
      borderDisabled: hexToRgba(gray['3'], 56),
      borderHover: gray['1'],
      borderError: negative['1']
    },
    label: gray['1'],
    message: gray['1']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['1'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(black['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: white['1'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: black['3'],
    secondary: gray['1']
  },
  paper: __assign(__assign({}, paletteLight.paper), {
    background: white['1']
  }),
  modal: {
    backdrop: hexToRgba(black['0'], 32)
  },
  dialog: {
    background: white['1']
  },
  dropDown: {
    background: white['1']
  },
  dividerLegacy: {
    primary: light['4'],
    secondary: light['4']
  },
  switch: {
    icon: white['1'],
    shadow: paletteLight.switch.shadow,
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(gray['1'], 8),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: gray['5'],
    backgroundSecondary: white['2']
  },
  snackbar: {
    text: white['2'],
    background: black['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
});

export default limexLightPalette;